<app-breadcrumb [master]="'Należności'" [parentName]="'Wpłaty'" [name]="'Przeksięgowania'"></app-breadcrumb>
<div class="regional-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane przeksięgowania</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div  fxFlex="100">
              <app-dict-receivables-balance fxFlex="100" label="Saldo nadawcy" [formControl]="receivablesBalanceOldControl" [required]="true">
                ></app-dict-receivables-balance>
            </div>


          </div>


          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Tytuł</mat-label>
                <input appCapitalizeFirst matInput placeholder="Tytuł" [formControl]="transferTitleControl">
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Kwota przeksięgowania</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="Kwota przeksięgowania"
                  [formControl]="transferAmountControl"
                  step="0.01"
                  min="0.01"
                />
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div  fxFlex="100">
              <app-dict-receivables-balance fxFlex="100" label="Saldo odbiorcy" [formControl]="receivablesBalanceNewControl" [required]="true">
                ></app-dict-receivables-balance>
            </div>


          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <input appCapitalizeFirst matInput placeholder="Uwagi" [formControl]="noteControl">
              </mat-form-field>
            </div>

          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

